(function () {
  'use strict';

  /**
   * @ngdoc object
   *
   *
   * @description
   *
   */
angular
    .module('crewProfile')
    .controller('CrewPreferenceHistoryController', CrewPreferenceHistoryController);

    function CrewPreferenceHistoryController($uibModalInstance, modalParams, ProfileService) {
        var vm = this;

        vm.model = {
            crewLayoverAccommodationPreferences : []
        };

        function getCrewLayoverAccommodationPreferences() {
            var param = {};
            param.crewProfileId = modalParams.crewProfileId;
            ProfileService.getAllCrewLayoverAccommodationPreferences(param,
                function (response) {
                    vm.model.crewLayoverAccommodationPreferences = response;
                },
                function (error) {
                    console.log('Crew Layover Accommodation Preference data retrieval error')
                }
            );
        }

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        getCrewLayoverAccommodationPreferences();
    }
}());
